"use client";
import { createAnatomy } from "@zag-js/anatomy";
//#region src/components/fieldset/fieldset.anatomy.ts
var fieldsetAnatomy = createAnatomy("fieldset").parts("root", "errorText", "helperText", "legend");
var parts = fieldsetAnatomy.build();
//#endregion
export { fieldsetAnatomy, parts };
